import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';
import { UpdateAvatarProjectInput } from '../../../types/avatar-video';

/**
 * Llama al endpoint `PUT /avatars/project/{id}`. El backend hace diff por hash
 * contra los scene records existentes y devuelve `regeneratedScenes`, útil para
 * mostrar en la UI cuántas escenas van a re-procesarse.
 *
 * Devuelve null si falla — el caller decide si mostrar toast/mensaje al user.
 */
export const useUpdateAvatarProject = () => {
  const { callEndpoint } = useAPIContext();

  const updateAvatarProject = React.useCallback(
    async (projectId: string, payload: UpdateAvatarProjectInput) => {
      try {
        const res = await callEndpoint<AvatarsAPI, 'update-avatar-project'>(
          'avatars',
          `/project/${projectId}`,
          'PUT',
          payload
        );
        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error al actualizar proyecto:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { updateAvatarProject };
};
